/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/



export default [{
        url: "/clinics-registered",
        name: "Clínicas cadastradas",
        slug: "clinics-registered",
        icon: "CheckCircleIcon",
        i18n: "clinics-registered"
    },
    {
        url: "/clinic-and-professionals",
        name: "Novas clínicas",
        slug: "new-clinic-and-professionals",
        icon: "PlusCircleIcon",
        i18n: "new-clinic-and-professionals"
    },
  {
    url: "/clinic-reports",
    name: "Relatórios",
    slug: "clinic-reports",
    icon: "FileTextIcon",
    i18n: "clinic-reports",
    submenu: [
      {
        url: "/clinics-registered-report",
        name: "Clínicas cadastradas",
        slug: "report-clinics-registered",
        i18n: "clinics-registered-report"
      },
      {
        url: "/quicksight-clinic-dashboard",
        name: "Painéis BI",
        slug: "quicksight-clinic-dashboard",
        i18n: "quicksight-clinic-dashboard",
      },
    ]
  },
]
